// src/components/Hero/Footer.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import DroneSVGWEB from "../../assets/DroneSVGWEB.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="w-full bg-white border-t border-gray-200 py-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start justify-between px-4 sm:px-6 gap-6">
        {/* Left Logo + Text */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left gap-2 w-full md:w-auto">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-2"
          >
            <img src={DroneSVGWEB} alt="AssetEye Logo" className="mx-auto mb-6 h-10" />
          </motion.div>
          <p className="text-xs hidden text-gray-500 md:flex items-center gap-1">
            © {t("footer.year")} | {t("footer.allRightsReserved")}
          </p>
        </div>

        {/* Center Nav + Contact */}
        <div className="flex flex-col items-center md:items-center gap-2 text-sm text-gray-600 w-full md:w-auto">
          <nav className="flex flex-wrap justify-center gap-4 md:gap-6 font-medium text-gray-700">
            <Link to="/" className="hover:text-green-800">
              {t("footer.nav.home")}
            </Link>
            <Link to="/about" className="hover:text-green-800">
              {t("footer.nav.about")}
            </Link>
            <Link to="/contact" className="hover:text-green-800">
              {t("footer.nav.contact")}
            </Link>
          </nav>
          <p className="text-center text-xs">{t("footer.contactInfo")}</p>
        </div>

        {/* Right Social + Links */}
        <div className="flex flex-col items-center md:items-end gap-3 w-full md:w-auto">
          <p className="text-sm font-medium text-gray-700">Follow Us On</p>
          <div className="flex gap-4 justify-center md:justify-end">
            <Link
              to="#"
              className="p-2 rounded-full bg-gray-100 hover:bg-green-800 hover:text-white transition"
            >
              <FaFacebookF size={16} />
            </Link>
            <Link
              href="#"
              className="p-2 rounded-full bg-gray-100 hover:bg-green-800 hover:text-white transition"
            >
              <FaInstagram size={16} />
            </Link>
            <Link
              to="#"
              className="p-2 rounded-full bg-gray-100 hover:bg-green-800 hover:text-white transition"
            >
              <FaLinkedinIn size={16} />
            </Link>
          </div>
          <div className="flex flex-wrap gap-4 justify-center md:justify-end text-xs text-gray-500">
            <Link to="#" className="hover:text-green-800">
              {t("footer.privacyPolicy")}
            </Link>
            <Link to="#" className="hover:text-green-800">
              {t("footer.termsAndConditions")}
            </Link>
          </div>
        </div>
        {/* Mobile only: copyright at bottom */}
        <div className="block md:hidden w-full">
          <p className="text-xs text-gray-500 flex items-center gap-1 justify-center">
            © {t("footer.year")} | {t("footer.allRightsReserved")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
